import React from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import Fields from 'components/common/Fields'
import FieldTracking from 'components/FieldTracking'
import getSelectedPostedBy from 'components/common/getSelectedPostedBy'
import {
  required,
  noSpaces,
  fieldHasErr,
  inputHasErr,
  noRepeatingCharacters,
  noSpecialCharacters,
  characterLimit,
  composeValidators,
} from 'utils/validations'

const namesStringMap = {
  Self: 'Your Name',
  Daughter: "Your daughter's name",
  Son: "Your son's name",
  Sister: "Your sister's name",
  Brother: "Your brother's name",
  Friend: "Your friend's name",
  Relative: "Your relative's name",
}

function hasNumber(input) {
  return /\d/.test(input)
}

const getPostedByString = postedBy => {
  return namesStringMap[postedBy]
}

const resetFieldsIfNumberInput = (firstName, lastName) => {
  let firstNameVal = firstName.input.value
  let lastNameVal = lastName.input.value

  if (hasNumber(firstNameVal)) {
    firstName.input.onChange('')
  }

  if (hasNumber(lastNameVal)) {
    lastName.input.onChange('')
  }
}

const FullName = () => {
  return (
    <>
      <Fields names={['postedby']}>
        {({ postedby }) => {
          return (
            <label className={formStyles.layerLable}>
              {getPostedByString(getSelectedPostedBy(postedby.input.value))}
            </label>
          )
        }}
      </Fields>
      <div className="form-row">
        <Field
          name="first_name"
          validate={composeValidators(
            required('first_name'),
            noSpaces('first_name'),
            characterLimit('First name', 20),
            noRepeatingCharacters,
            noSpecialCharacters
          )}
        >
          {({ input, meta }) => (
            <div className="col-6">
              <input
                data-testid="first_name"
                className={`${inputHasErr(meta) &&
                  formStyles.inputError} form-control ${
                  formStyles.formTextFreeField
                }`}
                type="text"
                {...input}
                placeholder="First Name"
              />
            </div>
          )}
        </Field>
        <FieldTracking name="first_name" />
        <Field
          name="last_name"
          validate={composeValidators(
            required('last_name'),
            noSpaces('last_name'),
            characterLimit('Last name', 20),
            noRepeatingCharacters,
            noSpecialCharacters
          )}
        >
          {({ input, meta }) => (
            <div className="col-6">
              <input
                data-testid="last_name"
                className={`${inputHasErr(meta) &&
                  formStyles.inputError} form-control ${
                  formStyles.formTextFreeField
                }`}
                type="text"
                {...input}
                placeholder="Last Name"
              />
            </div>
          )}
        </Field>
        <FieldTracking name="last_name" />
        <Fields names={['first_name', 'last_name']}>
          {/* eslint-disable-next-line camelcase */}
          {({ first_name, last_name }) => {
            resetFieldsIfNumberInput(first_name, last_name)
            const fullNameErr =
              fieldHasErr(first_name) || fieldHasErr(last_name)
            return fullNameErr ? (
              <p
                data-testid="name_error"
                className={`${formStyles.error} col-md-12`}
              >
                {first_name.meta.error || last_name.meta.error}
              </p>
            ) : null
          }}
        </Fields>
      </div>
    </>
  )
}

export default FullName
